import React from 'react'
import { SignUpPageStyled } from './SignUpPage.styled'
import { AccountHeader } from '@mobi/component-library/Areas/Account'
import { getSignUpState } from '@mobi/account/Areas/SignUp/Store'
import { DepositLimitForm } from '@mobi/account/Areas/DepositLimit/Components/DepositLimitForm'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { routes, trackSignUpSetDepositLimits } from '../Utils'
import { useBetAccount } from '@mobi/account/Hooks'

export const DepositLimit = () => {
  const signUpState = useSelector(getSignUpState)
  const navigate = useNavigate()
  const { data } = useBetAccount()

  if (
    signUpState?.isNewUserAutoLoggedIn === false ||
    !data?.BetAccountNumber ||
    !signUpState?.signupApplication
  ) {
    navigate(routes.home)
    return null
  }

  return (
    <SignUpPageStyled>
      <AccountHeader
        alignItems='start'
        title={`You're almost finished, ${signUpState?.signupApplication?.firstName}`}
        description='Would you like to set a deposit limit? Your deposit limit can also be set later.'
        style={{ marginBottom: '0rem' }}
      />
      <DepositLimitForm
        onDepositLimitSave={(frequency, amount) => trackSignUpSetDepositLimits(frequency, amount)}
        precommitmentDetails={{
          OptInMarketingIndicator: signUpState?.signupApplication?.marketingOptInIndicator ?? false,
        }}
        betAccountNumber={data?.BetAccountNumber ?? 0}
        isSignupFlow
      />
    </SignUpPageStyled>
  )
}
